module.exports = "body, html {\n  height: 100%;\n  margin: 0; }\n"